__turbopack_context__.v({
  "red": "COXIDG_red",
  "root": "COXIDG_root",
});
